import {
  amber, blue, cyan, deepOrange, deepPurple, green, indigo, lightGreen, lime, orange, pink, purple, red, teal, yellow,
} from "@mui/material/colors"

export const swatches: string[] = [
  // Rood naar paars
  red[500],
  pink[500],
  purple[500],

  // Paars naar blauw
  deepPurple[500],
  indigo[500],
  blue[500],

  // Blauw naar groen
  cyan[500],
  teal[500],
  green[500],

  // Groen naar geel
  lightGreen[500],
  lime[500],
  yellow[500],

  // Geel naar rood
  amber[500],
  orange[500],
  deepOrange[500],
  red[500],  // Sluit de cirkel

  // Rood naar paars
  red[900],
  pink[900],
  purple[900],

  // Paars naar blauw
  deepPurple[900],
  indigo[900],
  blue[900],

  // Blauw naar groen
  cyan[900],
  teal[900],
  green[900],

  // Groen naar geel
  lightGreen[900],
  lime[900],
  yellow[900],

  // Geel naar rood
  amber[900],
  orange[900],
  deepOrange[900],
  red[900],  // Sluit de cirkel
]
